/**
 * Gravity forms floating labels.
 */
$(document).on('gform_post_render', function(event, form_id, current_page){
	const activeClass = 'is-active';
	const wrapperSelector = '.gfield, .gform-grid-col';
	const $selectors = $('.js-gform input[type=text], .js-gform input[type=tel], .js-gform input[type=email], .js-gform input[type=number], .js-gform textarea');

	// Inline label forms: Add active class if input has value
	$selectors.each(function () {
		if ($(this).val().length) {
			$(this).closest(wrapperSelector).addClass(activeClass);
		}
	});

	$('.js-gform select').on('change', function() {
		if ($(this).val() === "") {
			$(this).closest('.gfield').removeClass(activeClass);
		} else {
			$(this).closest(wrapperSelector).addClass(activeClass);
		}
	});

	// Inline label forms: Add active class on focus
	$selectors.on('focus', function () {
		$(this).closest(wrapperSelector).addClass(activeClass);
	});

	// Inline label forms: Remove active class on blur
	$selectors.on('blur', function () {
		if (!$(this).val().length || $(this).val().includes('_')) {
			$(this).closest(wrapperSelector).removeClass(activeClass);
		}
	});
});
